module.exports = __webpack_public_path__ + "img/company-document-2.c98b2f59.svg";